import { render, staticRenderFns } from "./Subsidiaries.vue?vue&type=template&id=0f520365&scoped=true"
import script from "./Subsidiaries.vue?vue&type=script&setup=true&lang=js"
export * from "./Subsidiaries.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Subsidiaries.vue?vue&type=style&index=0&id=0f520365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f520365",
  null
  
)

export default component.exports